import cx from 'classnames';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import Sections from '~/constants/sections';
import { useIsNative } from '~/context/common/DeviceContext';
import { useConstructBreadcrumbs } from '~/hooks/vdp';
import useShouldShowStatusDataForExperiment from '~/hooks/vdp/useShouldShowStatusDataForExperiment';
import { getIsLite } from '~/selectors';
import { Section, SectionContent, Crumbs } from './BreadCrumbs.styles';
import { CaretRight } from './icons';
import Actions, { ActionsLocations } from '../Actions/Actions';

export default function BreadCrumbs() {
  const isLite = useSelector(getIsLite);
  const isNative = useIsNative();
  const breadCrumbs = useConstructBreadcrumbs();
  const hasStatusBanner = useShouldShowStatusDataForExperiment();

  if (isNative) return null;

  return (
    <Section
      id={Sections.BreadCrumbs}
      className={cx({
        'border-b border-grey-2': isLite,
        'm:pb-8 l:pb-0': hasStatusBanner
      })}
      whiteBg
    >
      <SectionContent>
        {breadCrumbs.map(({ label, href, key }, index) => {
          const isFirstCrumb = index === 0;
          const isLastCrumb = index === breadCrumbs.length - 1;

          return (
            <Fragment key={key}>
              {!isFirstCrumb && <CaretRight />}
              <Crumbs
                className={cx({ truncate: isLastCrumb })}
                data-analytics-id="Breadcrumbs"
                data-analytics-attributes={JSON.stringify({
                  label,
                  category: key
                })}
                href={href}
              >
                {label}
              </Crumbs>
            </Fragment>
          );
        })}
      </SectionContent>
      <Actions location={ActionsLocations.Breadcrumbs} />
    </Section>
  );
}
